import { getCurrentSubdomain } from './subdomain';

/**
 * The account (subdomain) the visitor is on. Browser storage keys are scoped by it so two tenants
 * served from one origin (local development) never read each other's plans or transcript.
 * Mirrors the fallback the API client uses for X-Subdomain.
 */
export const getStorageScope = (): string =>
  getCurrentSubdomain() || (import.meta.env.VITE_DEFAULT_SUBDOMAIN as string | undefined) || 'default';

export const chatTranscriptKey = (): string => `citiguide.chat.${getStorageScope()}`;
export const savedPlansKey = (): string => `citiguide.plans.${getStorageScope()}`;
